import { Box, InputAdornment, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { HeaderFilterBox, CustomTextField, CustomSelect } from '../../../../common/components';

const ConstructionTypesFilters = ({ searchTerm, selectedPlan, plans = [], onSearchChange, onPlanChange }) => {
  return (
    <HeaderFilterBox variant="oneRow">
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', width: '100%' }}>
        <CustomTextField
          label="Buscar"
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          size="medium"
          sx={{ width: { xs: '100%', sm: '48%', md: '28%' }, mt: 0 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'primary.main' }} />
              </InputAdornment>
            ),
          }}
        />

        <CustomSelect
          label="Plan"
          name="uuid_plan"
          value={selectedPlan || ''}
          onChange={onPlanChange}
          size="medium"
          sx={{ width: { xs: '100%', sm: '48%', md: '28%' }, mt: 0 }}
        >
          <MenuItem value="">Todos</MenuItem>
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>
    </HeaderFilterBox>
  );
};

export default ConstructionTypesFilters;
